import InviteContractorsArgs from "../entities/InviteContractorsArgs";
import axios from "axios";
import getAuthData from '@/utils/getAuthData';

export const inviteContractors = async ({
  users,
  companyId,
  companyBusinessName,
  invitedByUserId,
  drafted,
}: InviteContractorsArgs) => {
  const { headers } = await getAuthData();

  const uri = `${process.env.VUE_APP_LAMBDA}/create-invite-contractors`;
  try{
  await axios.post(
    uri,
    {
      users,
      company_id: companyId,
      company_business_name: companyBusinessName,
      created_by: invitedByUserId,
      drafted: drafted,
    },
    { headers }
  );
  return;
  }
  catch (error) {
    console.error("Failed to add contractor to company", error);
  }
};
